import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import List from '../components/List'

function CurationNotes() {
    var heroTitle = "Caveats and Curation Notes"
    var heroSubtitle = ""

    var cardHeader = ""

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                <ul>
                    <li>
                            In most instances, EPA did not provide metadata records for the FOIA responses, meaning that PEER had to catalog and apportion each document into a “bin” of “Year,” “Document Type” and “Statute.” 
                    </li>
                    <li>
                            PEER used a mixture of Large Language Models and manual review to curate the data. Because some of the data were automatically processed, it is possible that data were put into the wrong category. Click on “Report a Data Issue” if you would like to report a data error. 
                    </li>
                    <li>
                            PEER auto-generated document summaries, which can be helpful in quickly scanning through documents, but sometimes contains information that is not helpful enough (meaning the viewer should click on the actual document).
                    </li>
                </ul>
            </Card>
        </div>
    )
}

export default CurationNotes